var _path, _path2, _path3, _path4, _path5, _circle, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadVideo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.3475 7.44071L8.80642 11.8069C3.94448 12.8403 0.840862 17.6194 1.8743 22.4814L9.98285 60.6291C11.0163 65.4911 15.7954 68.5947 20.6574 67.5613L40.8309 63.2732C39.7536 62.2417 38.7029 60.5725 38.7029 58.3511C38.7029 56.0547 39.8258 54.3483 40.9405 53.3263C41.9125 52.4351 42.9629 51.9632 43.5699 51.7215C44.6435 51.2941 45.945 50.9911 46.7678 50.7995L47.0111 50.7427C47.2624 50.6835 47.4969 50.6274 47.7167 50.5732L40.0221 14.3728C38.9886 9.51089 34.2095 6.40727 29.3475 7.44071ZM33.4369 34.6157C34.9743 35.1152 35.3945 37.0918 34.1931 38.1735L23.1879 48.0827C21.9865 49.1644 20.0647 48.5399 19.7286 46.9587L16.6496 32.4733C16.3135 30.892 17.8152 29.5399 19.3526 30.0394L33.4369 34.6157Z",
    fill: "url(#paint0_linear_803_20140)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9757 32.4262L63.7829 41.4205C63.6584 41.2592 63.5236 41.0977 63.3774 40.9383C62.5048 39.9867 61.1329 39.0287 59.3205 38.7694L62.5713 20.3337C62.6841 19.6936 62.7364 19.0568 62.7323 18.4293L65.6815 20.132C69.9861 22.6173 71.461 28.1216 68.9757 32.4262Z",
    fill: "url(#paint1_linear_803_20140)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6185 22.5066L54.5558 39.876C54.0748 40.2042 53.6644 40.5719 53.3282 40.9386C52.437 41.9107 51.965 42.961 51.7233 43.568C51.5133 44.0955 51.3333 44.6781 51.1819 45.2318L44.4237 13.4372C44.2351 12.55 43.9634 11.7019 43.6185 10.8992L50.3181 12.0805C55.2131 12.9437 58.4817 17.6116 57.6185 22.5066Z",
    fill: "url(#paint2_linear_803_20140)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6173 22.5059L54.5546 39.8752C54.0735 40.2035 53.6632 40.5711 53.3269 40.9379C52.4357 41.9099 51.9638 42.9603 51.7221 43.5673C51.5121 44.0948 51.3321 44.6773 51.1806 45.231L44.4225 13.4365C44.2339 12.5493 43.9622 11.7011 43.6172 10.8984L50.3168 12.0798C55.2119 12.9429 58.4804 17.6108 57.6173 22.5059Z",
    fill: "url(#paint3_linear_803_20140)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9755 32.4266L63.7826 41.4209C63.6582 41.2596 63.5233 41.0981 63.3772 40.9387C62.5045 39.9871 61.1327 39.0291 59.3203 38.7698L62.571 20.3341C62.6839 19.694 62.7362 19.0572 62.7321 18.4297L65.6812 20.1324C69.9859 22.6177 71.4608 28.122 68.9755 32.4266Z",
    fill: "url(#paint4_linear_803_20140)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 53.25,
    cy: 53.25,
    r: 18.75,
    fill: "#F7F7F7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.8015 42.0039C52.0613 40.6654 54.1887 40.6654 55.4485 42.0039L64.7297 51.8651C65.4543 52.6351 65.4176 53.8467 64.6476 54.5713C63.8777 55.296 62.6661 55.2593 61.9414 54.4893L55.0395 47.156V64.4733C55.0395 65.5306 54.1823 66.3878 53.125 66.3878C52.0677 66.3878 51.2105 65.5306 51.2105 64.4733V47.156L44.3086 54.4893C43.5839 55.2593 42.3723 55.296 41.6024 54.5713C40.8324 53.8467 40.7957 52.6351 41.5204 51.8651L50.8015 42.0039Z",
    fill: "url(#paint5_linear_803_20140)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_803_20140",
    x1: 41.25,
    y1: 67.5,
    x2: 41.25,
    y2: 0.749999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEBEBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_803_20140",
    x1: 41.25,
    y1: 67.5,
    x2: 41.25,
    y2: 0.749999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEBEBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_803_20140",
    x1: 41.25,
    y1: 67.5,
    x2: 41.25,
    y2: 0.749999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEBEBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_803_20140",
    x1: 20.0973,
    y1: 84.1733,
    x2: 20.0973,
    y2: -15.504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#818181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_803_20140",
    x1: 41.25,
    y1: 67.499,
    x2: 41.25,
    y2: 0.749021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B5B5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_803_20140",
    x1: 0.658659,
    y1: 88.7814,
    x2: 0.65866,
    y2: 23.7834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B5B5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadVideo);
export default __webpack_public_path__ + "static/media/upload-video.4ffbfa03e79ed9fc85d78c47802c5796.svg";
export { ForwardRef as ReactComponent };